import React, { createContext } from "react";

import useAuth from "../../hooks/useAuth.js";

const AuthContext = createContext();

const AuthProvider = ({ children }) => {
	const {
		loading,
		user,
		isAuth,
		licenseExpired,
		clearLicenseExpired,
		handleLogin,
		handleLogout,
		updateUser,
	} = useAuth();

	return (
		<AuthContext.Provider
			value={{
				loading,
				user,
				isAuth,
				licenseExpired,
				clearLicenseExpired,
				handleLogin,
				handleLogout,
				updateUser,
			}}
		>
			{children}
		</AuthContext.Provider>
	);
};

export { AuthContext, AuthProvider };
